/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".interactive-videos-modal .modal-dialog{width:37.5rem}.interactive-videos-modal .modal-content{border-radius:1rem;overflow:hidden;border:none;width:37.5rem}.interactive-videos-modal-iframe{width:37.5rem;display:block;margin-top:1rem;height:90vh}"];
export { styles as styles };
//# sourceMappingURL=interactive-videos-modal.component.scss.ngstyle.js.map


//////////////////
// WEBPACK FOOTER
// ./ts/app/components/interactive-videos-modal/interactive-videos-modal.component.scss.ngstyle.js
// module id = 1364
// module chunks = 27 28 29